import axios from "axios/index";
import store from "../stores/store";
import * as appConstants from "../constants/AppConstants";

class ApprovalService {
  constructor() {
    this.requestHeaders = {
      Authorization: "",
      "x-api-key": "",
      "X-Support-Locale": "en_US",
      Accept: "application/json",
    };
  }

  getRequestHeaders() {
    const state = store.getState();
    this.requestHeaders = {
      Authorization: state.AuthReducer.userAccessToken,
      "x-api-key": state.AppReducer.applicationConfig.support_anyware_api_key,
    };

    return this.requestHeaders;
  }

  getAPIbaseUrl() {
    const state = store.getState();
    return (
      state.AppReducer.applicationConfig.support_anyware_api_url +
      "/products_support/approval_service/"
    );
  }

  getApprovalFlows = async (customerGuid) => {
    return await axios({
      url: this.getAPIbaseUrl() + "customer/" + customerGuid + "/flows",
      method: "get",
      headers: this.getRequestHeaders(),
    });
  };

  getApprovalList = async (flowInfoId) => {
    const state = store.getState();
    return await axios({
      url:
        this.getAPIbaseUrl() +
        "customer/" +
        state.AuthReducer.userInfo.userId +
        "/approvals?flowId=" +
        flowInfoId,
      method: "get",
      headers: this.getRequestHeaders(),
    });
  };

  getApprovalDetails = async (approvalId) => {
    const state = store.getState();
    return await axios({
      url:
        this.getAPIbaseUrl() +
        "customer/" +
        state.AuthReducer.userInfo.userId +
        "/approvals/" +
        approvalId,
      method: "get",
      headers: this.getRequestHeaders(),
    });
  };

  approveRequest = async (approvalId) => {
    const state = store.getState();
    const customer_guid = state.AuthReducer.userInfo.userId;
    return await axios({
      url:
        this.getAPIbaseUrl() +
        "customer/" +
        state.AuthReducer.userInfo.userId +
        "/approvals/" +
        approvalId +
        "?action=APPROVE&reason=approved_by_customer&actioned_by=" +
        customer_guid,
      method: "post",
      headers: this.getRequestHeaders(),
    });
  };

  rejectRequest = async (approvalId) => {
    const state = store.getState();
    const customer_guid = state.AuthReducer.userInfo.userId;
    return await axios({
      url:
        this.getAPIbaseUrl() +
        "customer/" +
        state.AuthReducer.userInfo.userId +
        "/approvals/" +
        approvalId +
        "?action=REJECT&reason=" +
        state.ApproveRejectReducer.selectedReason +
        "&actioned_by=" +
        customer_guid,
      method: "post",
      headers: this.getRequestHeaders(),
    });
  };

  decimalFilterForCountry(currentLocalLanguage, price, country) {
    if (price) {
      var productPrice =
        price !== "" && typeof price === "string"
          ? parseFloat(price.replace(/,/g, ""))
          : Number(price);
      if (isNaN(productPrice)) return;
      if (appConstants.THREE_DECIMAL_PRICE_COUNTRIES.includes(country)) {
        return new Intl.NumberFormat(currentLocalLanguage, {
          minimumFractionDigits: 3,
        }).format(parseFloat(productPrice));
      } else {
        return new Intl.NumberFormat(currentLocalLanguage, {
          minimumFractionDigits: 2,
        }).format(parseFloat(productPrice));
      }
    } else if (
      price === undefined ||
      price === null ||
      price === 0 ||
      price.length === 0
    ) {
      price = 0;
      if (appConstants.THREE_DECIMAL_PRICE_COUNTRIES.includes(country)) {
        return new Intl.NumberFormat(currentLocalLanguage, {
          minimumFractionDigits: 3,
        }).format(parseFloat(price));
      } else {
        return new Intl.NumberFormat(currentLocalLanguage, {
          minimumFractionDigits: 2,
        }).format(parseFloat(price));
      }
    }
  }

  getFloodGateRequestHeaders() {
    const state = store.getState();
    return {
      "Authorization": state.AuthReducer.userAccessToken,
      "x-api-key": state.AppReducer.applicationConfig.client_id,
      'x-gw-ims-org-id':'9E1005A551ED61CA0A490D45@AdobeOrg',
      'x-sandbox-name':state.AppReducer.applicationConfig.floodgate_api_sandbox_name
    };
  }

  getConfig = async () => {
    return await axios({
      url: process.env.PUBLIC_URL + "/config.json",
      method: "get",
    });
  };

  getFloodGateAPIbaseUrl() {
    const state = store.getState();
    return state.AppReducer.applicationConfig.floodgate_api_url;
  }

  loadFeatureFlag() {
    const state = store.getState();
    return axios({
      url:
        this.getFloodGateAPIbaseUrl() +
        "/feature?clientId=" +
        state.AppReducer.applicationConfig.client_id +
        "&meta=true",
      method: "get",
      headers: {
        ...this.getFloodGateRequestHeaders(),
        'Content-Type': "application/json"
      },
    });
  }
  async getCurrencyConversionConfig(localCurrency, value) {
    const dataInfo = {
      currency: localCurrency,
      value: value,
    };
    const state = store.getState();
    const currencyUrl = state.AppReducer.applicationConfig.hendrix_api_url;
    return axios({
      url: currencyUrl + "/utilityServices/currencyrate.do",
      method: "post",
      headers: {
        "x-api-key": state.AppReducer.applicationConfig.client_id,
        Authorization: state.AuthReducer.userAccessToken,
        "Content-Type": "application/json",
      },
      data: dataInfo,
    });
  }
  async fetchDisclaimer(orderId, locale) {
    const state = store.getState();
    const hendrixUrl = state.AppReducer.applicationConfig.hendrix_api_url;

    const data = {
      query: `query Order($orderId: ID!, $termsInput: RenewalPriceInput!) {
  order(id: $orderId) {
    terms(input: $termsInput) {
      ... on DisclaimerTermsDocument {
        disclaimerTermsContent {
          variables {
            ... on InterpolationVariableScalar {
              name
              type
              scalarValue
            }
            ... on InterpolationVariableMultiformat {
              name
              type
              multiformatTextValue {
                text {
                  json
                }
                variables {
                  ... on InterpolationVariableScalar {
                  name
                  type
                  scalarValue
                }

                }
              }
            }
          }
          text {
            json
          }
        }
        termsType
      }
      ... on SubscriptionCancellationTermsDocument {
        subCanTermsContent
        termsType
      }
    }
  }
}`,
      variables: {
        orderId: orderId,
        termsInput: {
          svar: null,
          locale: locale.toLowerCase().split("_")[0],
          clientId: "HendrixService1",
        },
      },
    };

    return axios({
      url: `${hendrixUrl}/disclaimer/api/msg/fetch`,
      method: "post",
      headers: {
        Accept: "application/json",
        Authorization: state.AuthReducer.userAccessToken,
        "Content-Type": "application/json",
        "x-api-key": "HendrixService1",
      },
      data: data,
    });
  }
}

const approvalService = new ApprovalService();
export default approvalService;
